import { ProtectedComponent } from '@components'

import { Button, ButtonsGroup } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { ExpensesTrackingEvents } from '@views/receipts/enums/tracking'

import { Scope } from '../../../../../../../enums/scope'
import { useSegment } from '../../../../../../../hooks'
import { useOrganizationViewUrl } from '../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../utils/routing/reactRoute'
import { BillsDropzone } from '../BillsDropzone'
import { BillsHandleAllDraftsButton } from '../BillsHandleAllDraftsButton'

export const BillsSideActions = (): ReactElement => {
  const { track } = useSegment()
  const location = useLocation()
  const { t } = useTranslation()
  const { url: billsNewUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getNewBillRoute())
  const { url: billsSettingsUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getSettingsRoute())
  const { url: billsNewCreditNoteUrl } = useOrganizationViewUrl(reactRoute.organization.bills.getNewCreditNoteRoute())

  const trackAction = useCallback(
    (action: string) => {
      track('XXX - Jesper - Action Taken', {
        context: 'bills_list',
        action,
      })
    },
    [track],
  )

  const handleCreateBillClick = useCallback(() => {
    track(ExpensesTrackingEvents.CreatePurchaseClicked, {
      source: 'Main CTA - Purchase page',
    })
    trackAction('create bill')
  }, [trackAction, track])

  const handleCreateCreditNoteClick = useCallback(() => {
    track(ExpensesTrackingEvents.CreateCreditNoteClicked, {
      source: 'Main CTA - Purchase page',
    })
    trackAction('create credit note for bill')
  }, [trackAction, track])

  return (
    <>
      <ButtonsGroup>
        <Button icon="settings" variant="outlined" to={billsSettingsUrl} />
        <ProtectedComponent scopes={Scope.BillWrite}>
          <Button
            icon="circlePlus"
            onClick={handleCreateBillClick}
            to={billsNewUrl && `${billsNewUrl}${location.search}`}
          >
            {t('bills.side_actions.create_bill')}
          </Button>
        </ProtectedComponent>
        <BillsHandleAllDraftsButton />
        <ProtectedComponent scopes={Scope.BillWrite}>
          <Button
            icon="receiptText"
            onClick={handleCreateCreditNoteClick}
            to={billsNewCreditNoteUrl && `${billsNewCreditNoteUrl}${location.search}`}
            variant="outlined"
          >
            {t('bills.side_actions.create_credit_note')}
          </Button>
        </ProtectedComponent>
      </ButtonsGroup>
      <BillsDropzone />
    </>
  )
}
